export let TypeaheadActionTypes;
(function (TypeaheadActionTypes) {
  TypeaheadActionTypes["StorePredicted"] = "[Typeahead] Store Predicted";
  TypeaheadActionTypes["UpdateTrackedUserInput"] = "[Typeahead] Update Track Typeahead User Input";
  TypeaheadActionTypes["SetClickedToSeeAll"] = "[Typeahead] Set Click To See All";
  TypeaheadActionTypes["ClearPredicted"] = "[Typeahead] Clear Predicted";
  TypeaheadActionTypes["UpdateSelectedValue"] = "[Typeahead] Update Selected Value";
  TypeaheadActionTypes["UpdateInputValue"] = "[Typeahead] Update Input Value";
})(TypeaheadActionTypes || (TypeaheadActionTypes = {}));